import { ITransportAccessibilityInsideSchema } from '../../repositories/newbuilding-card/entities/get_infrastructure/TransportAccessibilityInsideSchema';
import { ITransportAccessibilityOutsideSchema } from '../../repositories/newbuilding-card/entities/get_infrastructure/TransportAccessibilityOutsideSchema';
import { EInsideTAInfrastructureType, EOutsideTAInfrastructureType, TTAInfrastructureType } from '../../types/map';

export const POSSIBLE_OUTSIDE_INFRASTRUCTURE_TYPES = Object.values(EOutsideTAInfrastructureType);
export const POSSIBLE_INSIDE_INFRASTRUCTURE_TYPES = Object.values(EInsideTAInfrastructureType);

export const OUTSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP: Record<
  EOutsideTAInfrastructureType,
  keyof ITransportAccessibilityOutsideSchema
> = {
  [EOutsideTAInfrastructureType.busStops]: 'busStops',
  [EOutsideTAInfrastructureType.tramStops]: 'tramStops',
  [EOutsideTAInfrastructureType.metro]: 'metro',
  [EOutsideTAInfrastructureType.parking]: 'parking',
  [EOutsideTAInfrastructureType.bikeParking]: 'bikeParking',
  [EOutsideTAInfrastructureType.chargingStations]: 'chargingStations',
  [EOutsideTAInfrastructureType.scooterParking]: 'scooterParking',
};

export const INSIDE_INFRASTRUCTURE_TYPE_TO_PROPERTY_MAP: Record<
  EInsideTAInfrastructureType,
  keyof ITransportAccessibilityInsideSchema
> = {
  [EInsideTAInfrastructureType.yardWithoutCars]: 'yardWithoutCars',
  [EInsideTAInfrastructureType.parking]: 'parking',
  [EInsideTAInfrastructureType.dropOffPickUpArea]: 'dropOffPickUpArea',
  [EInsideTAInfrastructureType.bikeParking]: 'bikeParking',
  [EInsideTAInfrastructureType.chargingStations]: 'chargingStations',
  [EInsideTAInfrastructureType.scooterParking]: 'scooterParking',
  [EInsideTAInfrastructureType.boulevards]: 'boulevards',
  [EInsideTAInfrastructureType.trafficSafetyElements]: 'trafficSafetyElements',
};

export const INFRASTRUCTURE_TYPE_TO_TITLE_MAP: Record<TTAInfrastructureType, string> = {
  [EOutsideTAInfrastructureType.busStops]: 'Автобусная остановка',
  [EOutsideTAInfrastructureType.tramStops]: 'Трамвайная остановка',
  [EOutsideTAInfrastructureType.metro]: 'Метро',
  [EOutsideTAInfrastructureType.parking]: 'Парковка',
  [EOutsideTAInfrastructureType.bikeParking]: 'Велопарковка',
  [EOutsideTAInfrastructureType.chargingStations]: 'Зарядка электромобилей',
  [EOutsideTAInfrastructureType.scooterParking]: 'Парковка самокатов',

  [EInsideTAInfrastructureType.yardWithoutCars]: 'Двор без машин',
  [EInsideTAInfrastructureType.parking]: 'Парковка',
  [EInsideTAInfrastructureType.dropOffPickUpArea]: 'Быстрая остановка',
  [EInsideTAInfrastructureType.bikeParking]: 'Велопарковка',
  [EInsideTAInfrastructureType.chargingStations]: 'Зарядка электромобилей',
  [EInsideTAInfrastructureType.scooterParking]: 'Парковка самокатов',
  [EInsideTAInfrastructureType.boulevards]: 'Пешеходный бульвар',
  [EInsideTAInfrastructureType.trafficSafetyElements]: 'Элемент безопасности движения',
};

export const TRANSPORT_ACCESSIBILITY_SIDEBAR_WIDTH = 358;

export const MODAL_Z_INDEX = 10001;
